
function GridTabs ($uibModal, dialogs, $translate, tabs, prefs, listController) {
	
	var self = this;
	
	this.tabs = tabs;
	this.listController = listController;
	this.dynamic = null;
	//this.current = tabs[0];
	
	
	// activate tab by updating global params
	this.activateTab = function(tab) {
		//for (var member in self.filter) delete self.filter[member];
		self.current = tab;
		if (tab !== self.dynamic) self.dynamic = null;
		if (this.isTabActive(tab)) return;
		self.filter = {};
		angular.extend(self.filter, tab.filter);
		//self.listController.params.filter = self.filter;
		self.listController.setFilter(self.filter);
		self.listController.getPage();
	}
	
	this.isTabActive = function(tab) {
		if (!tab) return false;
		if (tab && tab === self.dynamic) return true;
		return angular.equals(tab.filter, self.filter);
	}
	
	this.searchChanged = function(filter) {
		self.filter = filter;
		var is_predefined = false;
		for (var i in self.tabs) {
			if (self.isTabActive(self.tabs[i])) {
				is_predefined = true;
				self.current = self.tabs[i];
			}
		}
		if (is_predefined) {
			// remove dynamic tab
			self.dynamic = null;
		} else {
			self.dynamic = {
				title: $translate.instant('New search'),
				icon: 'fa fa-pencil',
				dynamic: true,
			}
			self.current = self.dynamic;
		}
	}
	
	this.deleteTab = function(tab) {
		var index = self.tabs.indexOf(tab);
		if (index < 0) {
			alert("Błąd usuwania zakłądki!");
			return;
		}
		if (tab.mandatory) {
			alert("Nie możesz usunąć tej zakładki");
			return;
		}
		dialogs.confirm($translate.instant('Delete tab'), 
				$translate.instant('Do you really want to delete')+' "'+tab.title+'"?', {size:'md'}).result.then(function() {
			self.tabs.splice(index, 1);
			self.activateTab(self.tabs[0]);
		});
	}
	
	this.addTab = function() {
		var tab = {
			title: self.dynamic.title,
			filter: self.filter,
			icon: 'fa fa-filter'
		}
		
		var save = function(data) {
			self.tabs.push(data);
			self.dynamic = null;
			return self.saveTabs();
		}
		//var dlg = dialogs.create('framework/partials/grid/dialog-save-tab.html','SaveCancelDialogCtrl',{data:tab,save:save},{size:'lg'});
		var dlg = $uibModal.open({
		      animation: true,
		      templateUrl: 'framework/partials/grid/dialog-save-tab.html',
		      controller: 'SubmitCancelDialogCtrl as dCtrl',
		      size: 'md',
		      resolve: {
		        params: function () {
		          return {data:tab,submit:save}
		        }
		      }
		});
	}
	
	this.saveTabs = function() {
		var tabs = []
		for (var i in self.tabs) {
			var tab = self.tabs[i];
			tabs.push({
				title: tab.title,
				filter: tab.filter,
			});
		}
		return prefs.setItem('tabs', tabs);
	}
	
	this.activateDefalt = function() {
		//this.activateTab(this.tabs[0])
		var tab = this.tabs[0];
		self.listController.setFilter(tab.filter);
		self.searchChanged(tab.filter);
	}
	
}


function GridTabsManager($q, dialogs, $rootScope, $injector, $translate) {
	
	var self = this;
	this.dialogs = dialogs;
	this.getTabsFor = function(prefs, listController, predefinedFilters) {
		
		var tabs = prefs.getItem('tabs', []);
		if (typeof tabs.length != "number") tabs = [];
		for (var i in tabs) {
			tabs[i].icon = 'fa fa-filter';
			if (tabs[i].filter.length == 0) tabs[i].filter = {};
		}

		for (var t=predefinedFilters.length-1; t>=0; t--) {
			this.pushTab(tabs, predefinedFilters[t]);
		}
		/*
		this.pushTab(tabs, {
			title: $translate.instant('All'),
			icon: 'fa fa-list',
			filter: {},
			mandatory: true,  // cannot delete
			dynamic: false,   // saved, do not offer save dialog
		});
		*/

		var manager = $injector.instantiate(Grid.GridTabs, {prefs: prefs, tabs:tabs, listController:listController});
		
		// register options screen
		listController.options.push({
			'title': $translate.instant('Filter tabs'), 
			'templateUrl': 'framework/partials/grid/options-tabs.html',
			manager: manager, 
			save: function(){return manager.saveTabs()}
		});
		
		return manager
	}
	
	this.pushTab = function(tabs, tab) {
		var orig = this.getTabForFilter(tabs, tab.filter);
		if (!orig) {
			tabs.splice(0,0,tab);
		} else {
			orig.mandatory = tab.mandatory;
			orig.dynamic = tab.dynamic;
			orig.icon = tab.icon;
		}
	}
	
	this.getTabForFilter = function(tabs, filter) {
		for (var i in tabs) {
			var tab = tabs[i];
			if (angular.equals(tab.filter, filter)) {
				return tab;
			}
		}
		return null;
	}
	
	
}



Grid = window.Grid || {};
Grid.GridTabs = GridTabs;
Grid.GridTabsManager = GridTabsManager;


Grid.TabsComponent = {
    	templateUrl: 'framework/partials/grid/tabs.html',
    	bindings: {
    		listController: '=',
    		tabsType: '@',  // 'tabs' | 'pills'
			predefinedFilters: '<',
			onLoad: '&'
    	},
    	replace: true,
 		controllerAs: 'tabsCtrl',
    	controller: function(GridTabsManager, $q) {
    		
    		self = this;
    		this.tabsClass = this.tabsType || 'tabs'

			var predefinedFilters = $q.resolve(self.predefinedFilters);
    		console.debug("Tabs activate wait...")
    		$q.all([this.listController.promises.prefs, predefinedFilters]).then(function(params){
				console.debug("Tabs activate fired!")
				var prefs = params[0];
				var predefinedFilters = params[1];

    			// create tabs
    			self.tabs = GridTabsManager.getTabsFor(prefs, self.listController, predefinedFilters || [])  //.then(function(tabs){self.tabs = tabs});
				
				if (self.listController.session.getItem('filter', null) != null) {
					// got some seach
					self.tabs.searchChanged(self.listController.params.filter);
				} else {
					// opened for the first time
					self.tabs.activateDefalt()
				}
				
				// bind to search change
				self.listController.setFilter.subscribe(function(objects){
					self.tabs.searchChanged(self.listController.params.filter);
				});

				self.onLoad({});

				return prefs;
    		});
    		
    		window.tabsCtrl = this;
    	}
}